<!-- компонент для рисования способов оплат -->
<template>
	<div class="w5-payment-create-block">
		<div v-for="item in items" 
			class="w5-payment-create-list-item"
			:key="item.id"
			:class="{ 'selected': item.id == curValue, 'disabled': Props[item['id']]['disabled'], 'not-active-item': item.active !== true }"
			@click="onItemClick(item.id)">
			<div class="w5-payment-create-list-item-up">
				<img :src="APIServerUrl + '/uploads/payment/' + item['image']" />
				<div class="payment-name"><strong>{{ item['name'] | ftc }}</strong></div>
			</div>
			<div class="w5-payment-create-list-item-down">
				<div v-if="item['comission'] > 0" class="w5-payment-create-list-item-down-info">
					{{ 'payment/comission' | ftc }}: {{ item['comission'] }}%
				</div>
				<div v-if="item['bonus'] > 0" class="w5-payment-create-list-item-down-info">
					{{ 'payment/bonus' | ftc }}: {{ item['bonus'] }}%
				</div>
				<div><strong>{{ Props[item['id']]['summa'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></strong></div>
				<template v-if="getMin(item) && getMax(item)">
					<div>{{ item['min'] | moneyOnlyNumbers }} &mdash; {{ item['max'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
				</template>
				<template v-if="getMin(item) && !getMax(item)">
					<div>{{ 'main/range_from' | ftc }} {{ item['min'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
				</template>
				<template v-if="!getMin(item) && getMax(item)">
					<div>{{ 'main/range_to' | ftc }} {{ item['max'] | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"> </span></div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'paymentComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['items', 'value', 'title'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			curValue: null,
			curSumma: 0,
			Props: {}
		}
	},
	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		// параллельно ведем дополнительные свойства
		this.items.forEach(item => {
			this.Props[item['id']] = {
				'active': item['active'],
				'disabled': false,
				'summa': 0
			}
		})

		// устанавлилваем значение
		if (this.value !== undefined && this.value !== null)
			this.curValue = this.value

		// recountSum вызывать здесь не нужно
		// потому что будет установлена сумма в форме, и по этому событию
		// будет произведен вызов этой функции
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// подписка на уведомления об изменении суммы
		// без дебаунса - что бы быстро менять расчетный суммы
		EventBus.$on('form-client-operation-create', this.summaChanged)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка от уведомлений
		EventBus.$off('form-client-operation-create', this.summaChanged)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клик по тарифу
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onItemClick(id, isNextStep = true) {
			// эмуляция фокуса
			this.$emit('focus')

			// если итоговая сумма не задана
			if (!this.Props || !this.Props[id] ||
				this.Props[id]['summa'] === undefined ||
				this.Props[id]['summa'] === null ||
				isNaN(this.Props[id]['summa']) ||
				this.Props[id]['summa'] <= 0)
			{
				// ничего не делаем
				return
			}

			// ищем выбранный итем (в Props не все поля)
			let _item = null
			this.items.some(item => {
				if (String(item.id) === String(id))
				{
					_item = item
					return true
				}
			})
			// если не нашли
			if (!_item)
			{
				// ничего не делаем
				return
			}

			// если это клиент и кнопка неактивна
			if (this.$store.state.user_type !== 'admin' &&
				this.Props[id]['active'] !== true)
			{
				// если это платежка юрика клиентом - просто генерируем событие,
				// оно само сообщит родителям о смене значения
				if (_item.type === 'bank_legal' &&
					this.$store.state.user_type === 'client')
				{
					EventBus.$emit('w5-payment-bank-legal', id)
				}

				// более ничего не делаем
				return
			}

			// способ неактивен
			if (this.Props[id]['disabled'] === true)
			{
				// ничего не делаем
				return
			}

			// значение корректно и оно доступно - запоминаем новое значение
			this.curValue = id

			// сообщаем родителю что у нас поменялось значение
			this.$emit('input', this.curValue)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// событие: в форме изменилась сумма
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		summaChanged(summa) {
			// проверка входного параметра
			if (summa === undefined || summa === null || isNaN(summa)) summa = 0
			if (String(summa).length === 0) summa = 0

			// приводим к нужному виду для расчетов
			summa = parseFloat(summa)

			// обновляем переменную
			this.$set(this, 'curSumma', summa)

			// перерасчет итоговых сумм и доспуности кнопок
			this.recountSum()

			// данные не плоские - обновлять GUI нужно самим
			this.$forceUpdate()
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// перерасчет итоговой суммы и достуности способов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		recountSum() {
			if (!this.items || !this.items.length) return

			// ищем текущий способ
			let curPayment = null
			// бежим по всем способам
			this.items.forEach(item => {
				// если это текущий способ - запомним его
				if (item && String(item.id) === String(this.curValue))
				{
					curPayment = item
				}

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// получим размер комиссии
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				let _com = item['comission']
				if (_com === undefined || _com === null || isNaN(_com) || _com === '') _com = 0
				_com = parseFloat(_com)

				// расчитаем итоговую сумму для данного способа оплаты
				let _price = (this.curSumma + _com * this.curSumma / 100.0).toFixed(2)
				_price = parseFloat(_price)

				// запоминаем ее
				this.Props[item['id']]['summa'] = _price

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// получим минимальный и максимальный размеры
				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
				// min
				let _min = item['min']
				if (_min === undefined || _min === null || isNaN(_min) || _min === '') _min = 0
				_min = parseFloat(_min)

				// max
				let _max = item['max']
				if (_max === undefined || _max === null || isNaN(_max) || _max === '') _max = 0
				_max = parseFloat(_max)

				// кнопка доступна или нет
				if (this.curSumma <= 0 || this.curSumma < _min || (_max && this.curSumma > _max)) this.Props[item['id']]['disabled'] = true
				else this.Props[item['id']]['disabled'] = false

				//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			})

			// если нашли текущий способ - делаем проверки
			if (curPayment && curPayment.id)
			{
				// транслируем родителю значение
				if (curPayment.active !== true || this.Props[curPayment.id].disabled === true)
					this.$emit('input', null)
				else
					this.$emit('input', this.curValue)
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// отдает минимальную сумму если есть, и null - если нет
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getMin(item) {
			if (!item || !('min' in item) || item.min < 0) return null
			return item.min
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// отдает максимальную сумму если есть, и null - если нет
		// или если указано  магическое число
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getMax(item) {
			if (!item || !('max' in item) || item.max < 0) return null
			if (item.max >= 1000000) return null
			return item.max
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'value': function(value) {
			this.curValue = value
			this.recountSum()
		},
		'items': function(items) {
			// параллельно ведем дополнительные свойства
			items.forEach(item => {
				this.Props[item['id']] = {
					'active': item['active'],
					'disabled': false,
					'summa': 0
				}
			})
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-payment-create-block {
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;
}

.w5-payment-create-list-item {
	margin: 10px 15px 10px 0;
    width: 120px;
    border: 0px;
    background-color: white;
    text-align: center;
    font-size: 80%;
    cursor: pointer;
}
@media (max-width: 767px) {
	.w5-payment-create-list-item {
		margin: 10px 16px 10px 0;
	}
}

/* курсор над невыделенным тарифом */
.w5-payment-create-list-item:hover div.w5-payment-create-list-item-up {
	background-color: #dceeff !important;
    border-color: #3ba3ff !important;
    color: black;
}

.w5-payment-create-list-item:hover div.w5-payment-create-list-item-down {
    border-color: #3ba3ff !important;
}

/* выделенный тариф */
.w5-payment-create-list-item.selected div.w5-payment-create-list-item-up {
	background-color: #dceeff !important;
    border-color: #2c8ad8 !important;
    color: black;
}

.w5-payment-create-list-item.selected div.w5-payment-create-list-item-down {
    border-color: #2c8ad8 !important;
}

/* курсор над выделенным тарифом */
.w5-payment-create-list-item.selected:hover div.w5-payment-create-list-item-up {
	background-color: #dceeff !important;
    border-color: #3ba3ff !important;
    color: black;
}

.w5-payment-create-list-item.selected:hover div.w5-payment-create-list-item-down {
    border-color: #3ba3ff !important;
}

/* недоступный тариф */
.w5-payment-create-list-item.disabled {
	cursor: not-allowed;
}

.w5-payment-create-list-item.disabled img {
	opacity: 0.6;
}

.w5-payment-create-list-item.disabled div.w5-payment-create-list-item-up {
	background-color: #eee !important;
    border-color: #ccc !important;
    color: #aaa;
}

.w5-payment-create-list-item.disabled div.w5-payment-create-list-item-down {
    border-color: #ccc !important;
    color: #ccc;
}

/* недоступный выделенный тариф */
.w5-payment-create-list-item.selected.disabled {
	cursor: not-allowed;
	opacity: 0.6;
}

.w5-payment-create-list-item.selected.disabled div.w5-payment-create-list-item-up {
	background-color: #2c8ad8 !important;
    border-color: #2c8ad8 !important;
    color: white;
}

.w5-payment-create-list-item.selected.disabled div.w5-payment-create-list-item-down {
    border-color: #2c8ad8 !important;
}





.w5-payment-create-list-item-up {
	border: 1px solid #ddd !important;
    color: black;
    padding: 10px;
    border-radius: 4px 4px 0 0 !important;

    height: 150px;
    
    transition: background-color .2s;
    transition: border-color .2s;
}

.payment-name {
	display: table-cell;
    text-align: center;
    vertical-align: middle;
    width: 110px;
	height: 38px;
	line-height: 0.9;
	overflow: hidden;
}

.w5-payment-create-list-item-up > img {
	width: 100px;
	height: 100px;
}

.w5-payment-create-list-item-down {	
	display: flex;
	display: -webkit-box;
    display: -webkit-flex;
	
	align-items: center;
	-webkit-align-items: center;
	flex-direction: column;

	justify-content: center;		
	-webkit-justify-content: center;
	
	border-bottom: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
    border-left: 1px solid #ddd !important;
    border-radius: 0 0 4px 4px !important;

    padding: 10px 5px 5px;
    color: black;
    height: 60px;
    font-size: 95%;
    overflow: hidden;
    
    transition: border-color .2s;
}

.not-active-item > .w5-payment-create-list-item-up,
.not-active-item > .w5-payment-create-list-item-down {
	background-color: #f9f9f9;
}

</style>



// WEBPACK FOOTER //
// payment.vue?89b53fec